import LegalPage from "@/components/LegalPage";
import { SITE } from "@/lib/site";

export default function Terms() {
  return (
    <LegalPage
      title="Terms of Use"
      description="Terms governing access to and use of the AUT labs website."
      updated="13 August 2026"
      intro="These terms apply to this website. Any paid project is governed by its own signed proposal or service agreement."
    >
      <section>
        <h2>1. Using this website</h2>
        <p>
          You may use this website to learn about AUT labs and contact us about possible
          work. Do not misuse the site, interfere with its operation, attempt unauthorised
          access, introduce harmful code, or use its content unlawfully.
        </p>
      </section>

      <section>
        <h2>2. Illustrations, estimates and outcomes</h2>
        <p>
          Product screens, examples, calculations, time-saving estimates and case-style
          scenarios on this website are illustrative unless clearly stated otherwise.
          Actual scope, cost, timing, savings and results depend on your systems, data,
          people and agreed project terms. They are not guarantees.
        </p>
      </section>

      <section>
        <h2>3. No client relationship from website use</h2>
        <p>
          Booking a call, sending a form or exchanging initial messages does not create a
          client, partnership, employment or fiduciary relationship. Work begins only under
          mutually agreed written terms.
        </p>
      </section>

      <section>
        <h2>4. Project agreements control</h2>
        <p>
          A signed proposal, statement of work, service agreement or other written contract
          will set the scope, fees, responsibilities, confidentiality, data handling,
          intellectual property, support and liability terms for a project. If it conflicts
          with this website, the signed agreement controls for that project.
        </p>
      </section>

      <section>
        <h2>5. Website content and intellectual property</h2>
        <p>
          Unless stated otherwise, AUT labs owns or is permitted to use the website design,
          copy, graphics and code. You may view and share links to the site, but may not
          reproduce or commercially exploit substantial parts without written permission.
          Ownership of client deliverables is handled in the relevant signed agreement.
        </p>
      </section>

      <section>
        <h2>6. Third-party services</h2>
        <p>
          This website may link to or embed services such as calendars, email, maps or
          messaging platforms. Those services are operated by third parties under their own
          terms and privacy practices. AUT labs is not responsible for their availability
          or independent conduct.
        </p>
      </section>

      <section>
        <h2>7. Availability and liability</h2>
        <p>
          The website is provided on an as-available basis. To the fullest extent permitted
          by law, AUT labs does not warrant uninterrupted or error-free access and is not
          liable for indirect, incidental, special or consequential loss arising only from
          use of, or inability to use, this website.
        </p>
      </section>

      <section>
        <h2>8. Governing law</h2>
        <p>
          These website terms are governed by the laws of India. Subject to any mandatory
          rights or agreed dispute process, courts in Mumbai, Maharashtra will have
          jurisdiction over disputes concerning these terms.
        </p>
      </section>

      <section>
        <h2>9. Changes and contact</h2>
        <p>
          We may update these terms as the website or applicable requirements change. The
          effective date above shows the latest version. Questions can be sent to{" "}
          <a href={`mailto:${SITE.email}`}>{SITE.email}</a>.
        </p>
      </section>
    </LegalPage>
  );
}
